import { Box } from '@/components/lib/components';
import { useSbkBetSlipStore } from '@/feature/betslip-sbk/hooks/use-sbk-betslip-store';
import { validBetsSelector } from '@/feature/betslip-sbk/utils/betslip-selectors';
import { useShallow } from 'zustand/react/shallow';

import { SingleBetErrorWarning } from './SingleBetErrorWarning';
import { StakeInputSummaryWarnings } from './StakeInputSummaryWarnings';
import { SuspendedWarning } from './SuspendedWarning';
import { TotalStakeWarnings } from './TotalStakeWarnings';

export const EntrySummaryWarnings = () => {
    const validBetsWithStake = useSbkBetSlipStore(
        useShallow(state => validBetsSelector(state).filter(bet => !!bet.stake))
    );

    const isSingleBet = validBetsWithStake.length === 1;

    return (
        <Box gap="s12" pb="s8">
            <SuspendedWarning />
            {isSingleBet ? (
                <>
                    <SingleBetErrorWarning betId={validBetsWithStake[0].id} />
                    <TotalStakeWarnings showOnlyRgErrors />
                </>
            ) : (
                <>
                    <StakeInputSummaryWarnings />
                    <TotalStakeWarnings />
                </>
            )}
        </Box>
    );
};
